module.exports = __webpack_public_path__ + "static/media/EN-Option1.8bc36c75.jpg";